import BasePage from "components/basePage/BasePage";
import React, { useEffect, useState, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { showToast } from "services/helper";
import { getSearchTermDescriptor } from "services/requests";
import { StandardView } from "wm-standard-crud";

function Terms() {
  //STATE
  const [descriptor, setDescriptor] = useState({});
  const [loading, setLoading] = useState(false);
  //OTHERS
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    getSearchTermDescriptor()
      .then((data) => setDescriptor(data))
      .catch(() => {
        showToast(
          "Parece que não foi possível buscar as informações, tente novamente mais tarde.",
          "error"
        );
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <BasePage loading={loading} className="terms-page">
      <Fragment>
        <StandardView
          descriptor={descriptor}
          addBtnText={"Novo Termo"}
          addBtn={"add-btn"}
          addNew={() => navigate("/term")}
          onItemClick={(data) => navigate(`/term/${data?.id}`)}
        />
      </Fragment>
    </BasePage>
  );
}

export default Terms;
